import React from 'react'
import { useTranslation } from 'react-i18next'
import BaseFreeformPicker from '../BaseFreeformPicker/BaseFreeformPicker'
import ImagePicker from '../PageAssembler/InnerComponents/ImagePicker/ImagePicker'
import { PAGE_WIDTH } from '../../constants/pageDimensions'

const FreeformImagePicker = ({
  picker,
  onPositionCommit,
  onRotateCommit,
  onDelete,
  onActivate,
  stickerBoundsRef,
  pageOffset,
  isPrintView = false,
  zindex,
}) => {
  const [t] = useTranslation()

  const { pickerData = {} } = picker
  const { memoryId, caption = '', title = '', cropArea, hasCaption, isPlaceholder } = pickerData

  const hasImage = Boolean(memoryId)
  const resizeMode = hasImage ? 'corners' : 'freeform'

  return (
    <BaseFreeformPicker
      picker={picker}
      onPositionCommit={onPositionCommit}
      onRotateCommit={onRotateCommit}
      onDelete={onDelete}
      onActivate={onActivate}
      stickerBoundsRef={stickerBoundsRef}
      pageOffset={pageOffset}
      isPrintView={isPrintView}
      zindex={zindex}
      resizeMode={resizeMode}
      maxSize={PAGE_WIDTH}
      minSize={50}
      defaultSize={300}
      contentDescription={t('FreeformImagePicker.defaultDescription', 'Draggable image picker')}
      deleteButtonTitle={t('FreeformImagePicker.deleteButton.title', 'Remove draggable')}
      testIdPrefix={`freeform-image-picker-${picker.id}`}
      shouldWaitForContentReady
      renderContent={(contentProps) => (
        <ImagePicker
          pageNumber={contentProps.pageNumber}
          memoryId={memoryId}
          isPrintView={contentProps.isPrintView}
          caption={caption}
          title={title}
          positionIndex={0}
          cropArea={cropArea}
          customLayoutElementId={contentProps.customLayoutElementId}
          onUpdateCustomLayoutElementData={contentProps.onUpdateCustomLayoutElementData}
          isFreeformPicker
          noCaption={!hasCaption}
          onContentReady={contentProps.onContentReady}
          isPlaceholder={isPlaceholder}
          onCancelPlaceholder={onDelete}
        />
      )}
    />
  )
}

export default FreeformImagePicker
